import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    existingGroupTitle: (label: string, memberCount: number) => string | React.ReactNode;
    existingGroupDetails: string;
    existingGuestTitle: string;
    existingGuestDetails: (label: string) => string | React.ReactNode;
    member: string;
    existingMemberDetails: string;
    group: string;
    invalidEmail: string;
    newGuest: string;
    newMember: string;
    newMemberAdobeAccount: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for an existing group */
            existingGroupTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (label: string, memberCount: number) => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.existingGroupTitle?c=1ld1s23ygkhx4", defaultMessage: "{memberCount, plural, one {{label} contains 1 existing Member} other {{label} contains {memberCount} existing Members}}" }, { memberCount: memberCount, label: label }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when adding group as a guest */
            existingGroupDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.existingGroupDetails?c=cg7zuvuq4zqg", defaultMessage: "Groups can''t added as Guests." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for an existing guest */
            existingGuestTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.existingGuestTitle?c=1vvez9455tzq0", defaultMessage: "Guest in Another Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Details for an existing guest */
            existingGuestDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (label: string) => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.existingGuestDetails?c=2qb5h4z8kfb30", defaultMessage: "Guests can only access one project at a time. Adding {label} here will remove them from their existing project." }, { label: label }));
                },
                enumerable: true,
                configurable: true
            },
            /** Informational text when adding a member */
            member: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.member?c=14uuu5gc8lhnh", defaultMessage: "Members can be added to any project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Informational text when adding an existing member as guest */
            existingMemberDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.existingMemberDetails?c=uu859q7bvnpa", defaultMessage: "This user is already a paid Member and can''t be added as a Guest." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Informational text for a group */
            group: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.group?c=32m8s1ry4f1gs", defaultMessage: "Groups can be added to any Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Invalid email error message */
            invalidEmail: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.invalidEmail?c=3kz4safwma1jq", defaultMessage: "Please enter a valid email address" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for a new guest */
            newGuest: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.newGuest?c=km8z3eygrpjt", defaultMessage: "Add as new free Guest" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for a new member */
            newMember: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.newMember?c=6o8nq4z2mq4n", defaultMessage: "Add as new paid Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for a new member with an Adobe account */
            newMemberAdobeAccount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "memberAccessFormConstants.newMemberAdobeAccount?c=2jtx9auxza2rn", defaultMessage: "New members can only be added by an Adobe administrator." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
